import React from 'react';
import AppRouter from './AppRouter';
import ErrorBoundary from './ErrorBoundary';
import 'antd/dist/reset.css';
import './assets/_base_variables.scss';

const App = () => {
  return (
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  );
};

export default App;
